import React, { useCallback } from "react";
import { Stack, styled, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "../shared/Texts";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { useAppDispatch, useAppSelector } from "../../store";
import { makeStyles } from "@material-ui/core/styles";
import { NumFactuValidator } from "../../../core/validators/num.factu.validator";

const useStyles = makeStyles(() => ({
	input: {
		background: "rgb(255, 255, 255)",
		"&:hover": {
			background: "rgb(255, 255, 255)",
		},
		"&.Mui-focused": {
			background: "rgb(255, 255, 255)",
		},
	},
}));

const Title = styled("div")(({ theme }) => ({
	...theme.typography.button,
	backgroundColor: theme.palette.background.paper,
	paddingTop: theme.spacing(3),
	fontWeight: "bold",
	fontSize: "20px",
	textAlign: "left",
	color: "#B6AC42",
}));

export function NumeroFacturation() {
	const classes = useStyles();
	const dispatch = useAppDispatch();
	const { preferences, links } = useAppSelector((s) => s.expertise);
	const [error, setError] = React.useState(false);

	React.useEffect(() => {
		if (preferences?.numeroFacturation) {
			const isValid = NumFactuValidator.validate(preferences.numeroFacturation);
			setError(!isValid);
		}
	}, [preferences?.numeroFacturation]);

	const updatePreferences = useCallback(
		(newValue: string) => {
			dispatch(
				setPreferencesPartial({
					numeroFacturation: newValue,
				})
			);
		},
		[dispatch]
	);

	const handlenumeroFacturationChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const numFactu = e.target.value;
			const isValid = NumFactuValidator.validate(numFactu);

			setError(!isValid); // affiche l’erreur si invalide

			updatePreferences(numFactu);
		},
		[updatePreferences]
	);

	const theme = useTheme();
	const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"));

	if (!preferences) return null;

	return (
		<>
			<Title>Préférences générales de téléexpertise</Title>
			<Stack flexDirection={"column"} marginBottom={"25px"} width={"100%"} display={"flex"} alignItems={"left"} marginLeft={isLargeScreen ? "60px" : "0"} marginTop={"8px"}>
				<Stack flexDirection={"row"} alignItems={"center"} marginTop={"0px"}>
					<Typography color={"primary.main"} fontWeight={"bold"}>
						Votre numéro de facturation :
					</Typography>
					<TextField
						InputProps={{ className: classes.input }}
						hiddenLabel
						id="filled-hidden-label-small"
						value={preferences.numeroFacturation ?? ""}
						onChange={handlenumeroFacturationChange}
						variant="filled"
						size="small"
						error={error}
						sx={{ marginLeft: "8px" }}
					/>
				</Stack>
				<Typography fontSize={"smaller"} fontStyle={"italic"} marginTop={"6px"}>
					Quel est ce numéro, où le trouver ? <Link text="(en savoir plus)" href={links.numeroFacturation ?? ""} />
				</Typography>
			</Stack>
		</>
	);
}
